import React from 'react';
import {Route} from 'react-router-dom';

import {Scopes} from 'Services';

/**
 * @classdesc Route rendering
 */
export default class Main extends React.Component {
    key = 1;

    /**
     * @method renderRoute
     * @param {object} props
     * @param {object} props.user
     * @param {string} props.path
     * @param {string} props.exact
     * @param {object} props.company
     * @return {*}
     */
    renderRoute = (props) => {
        if (props.scopes === undefined || (props.scopes !== false && !Scopes.has(props.scopes))) {
            return null;
        }

        return (
            <Route
                path={props.path}
                exact={props.exact === undefined || props.exact}
                key={this.key++}
            >
                <props.component
                    user={this.props.user}
                    company={this.props.company}
                />
            </Route>
        );
    }
}
